export function tipOutEligible({
  timecardEligible,
  newTimecard,
  locationHasActiveTipPolicy,
}) {
  return timecardEligible || (newTimecard && locationHasActiveTipPolicy);
}
